export enum SignType {
  XMLDSIG = 'contract_xmldsig',
}
